"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesktopGallery = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const app_1 = require("app");
const React = require("react");
const bundle_1 = require("swiper/bundle");
const PreviewBox_1 = require("Views/Shared/Components/PreviewBox/PreviewBox");
const GalleryThumbnails_1 = require("../components/GalleryThumbnails");
const dialog_1 = require("../../ModalDialog/dialog");
const GalleryImageWrapper_1 = require("../components/GalleryImageWrapper");
const DesktopModalGallery_1 = require("./DesktopModalGallery");
const types_1 = require("../../ModalDialog/types");
class DesktopGallery extends React.Component {
    constructor() {
        super(...arguments);
        this.selectedIndex = 0;
        this.state = {
            isPopupOpened: false,
        };
        this.onTopGalleryClick = slideIndex => {
            var _a;
            const isDisabledPopupImage = (_a = this.props.galleryItems[slideIndex]) === null || _a === void 0 ? void 0 : _a.disableImagePopup;
            if (isDisabledPopupImage) {
                return;
            }
            this.setState({
                isPopupOpened: true,
            });
        };
        this.onVideoSlideClick = (event, slideIndex) => {
            const { isTablet } = this.props;
            event.preventDefault();
            if (isTablet) {
                this.openPreviewBox();
            }
            else {
                this.onTopGalleryClick(slideIndex);
            }
        };
        this.onVideoSlideKeyPress = (event, slideIndex) => {
            if (event.key === app_1.keyNameMapping.enter || event.key === app_1.keyNameMapping.space) {
                this.onVideoSlideClick(event, slideIndex);
            }
        };
        this.openPreviewBox = () => {
            const { galleryItems, popupAriaLabel, closeButtonAriaLabel } = this.props;
            if (this.swiperGalleryTop && !isNaN(this.swiperGalleryTop.activeIndex)) {
                const videoUrl = galleryItems[this.swiperGalleryTop.activeIndex].videoUrl;
                (0, PreviewBox_1.renderPreviewBox)(videoUrl, popupAriaLabel, closeButtonAriaLabel);
            }
        };
        this.closePopup = () => {
            this.setState({
                isPopupOpened: false,
            });
        };
        //business logic: for tablets when we have one image or when we have media single component - do not render thumbnails
        this.checkIfMediaShouldHaveThumbnails = () => {
            if (!this.props.isTablet && !this.props.hideThumbnails) {
                return true;
            }
            const { galleryItems } = this.props;
            return galleryItems && galleryItems.length > 1;
        };
    }
    componentDidMount() {
        const { uniqueClassName } = this.props;
        const shouldHaveThumbnails = this.checkIfMediaShouldHaveThumbnails();
        if (shouldHaveThumbnails) {
            this.swiperGalleryThumbnails = new bundle_1.default(`.${uniqueClassName} .gallery-thumbs`, {
                slidesPerView: 'auto',
                freeMode: true,
                watchSlidesProgress: true,
            });
        }
        this.swiperGalleryTop = new bundle_1.default(`.${uniqueClassName} .gallery-top`, {
            on: {
                click: (_swiper, event) => {
                    var _a, _b, _c;
                    const target = event.target;
                    const slideIndex = (_c = (_b = (_a = target.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.dataset) === null || _c === void 0 ? void 0 : _c.slideIndex;
                    if (!this.props.isTablet) {
                        this.onTopGalleryClick(slideIndex);
                    }
                },
            },
            thumbs: {
                swiper: this.swiperGalleryThumbnails,
                slideThumbActiveClass: 'group swiper-slide-active',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            spaceBetween: 10,
        });
    }
    render() {
        const { galleryItems, uniqueClassName, playButtonAriaLabel, popupAriaLabel, closeButtonAriaLabel, isMediaGallery, } = this.props;
        const { isPopupOpened } = this.state;
        const haveThumbnails = this.checkIfMediaShouldHaveThumbnails();
        const galleryTopClasses = `swiper-container gallery-top flex-1 ${!haveThumbnails ? 'gallery-without-thumbs' : ''} list-none mx-auto overflow-hidden p-0 relative z-1 touch-pan-y pb-8`;
        if (this.swiperGalleryTop) {
            this.selectedIndex = this.swiperGalleryTop.activeIndex;
        }
        return ((0, jsx_runtime_1.jsxs)("div", { className: `desktop-gallery relative ${uniqueClassName}`, children: [(0, jsx_runtime_1.jsx)("div", { className: galleryTopClasses, children: (0, jsx_runtime_1.jsx)("div", { className: `swiper-wrapper duration-0 box-content flex h-full relative transition-transform w-full z-1 ${uniqueClassName}`, children: galleryItems.map((item, index) => ((0, jsx_runtime_1.jsx)(GalleryImageWrapper_1.default, { mediaItem: item, itemKey: index, onVideoClick: event => this.onVideoSlideClick(event, index), onVideoSlideKeyPress: event => this.onVideoSlideKeyPress(event, index), isMainImage: true, playButtonAriaLabel: playButtonAriaLabel, mediaType: isMediaGallery ? types_1.PopupType.MEDIA : types_1.PopupType.SINGLE_MEDIA }, index))) }) }), haveThumbnails ? (0, jsx_runtime_1.jsx)(GalleryThumbnails_1.GalleryThumbnails, { galleryItems: galleryItems }) : '', (0, jsx_runtime_1.jsx)("div", { className: "gallery-modal-align", children: (0, jsx_runtime_1.jsx)(dialog_1.Dialog, { onClose: this.closePopup, title: "", isOpen: isPopupOpened, classes: "desktop-modal-gallery group", popupAriaLabel: popupAriaLabel, closeButtonAriaLabel: closeButtonAriaLabel, popupType: isMediaGallery ? types_1.PopupType.MEDIA : types_1.PopupType.SINGLE_MEDIA, children: (0, jsx_runtime_1.jsx)(DesktopModalGallery_1.default, { galleryItems: galleryItems, selectedIndex: this.selectedIndex, isMediaGallery: isMediaGallery }) }) })] }));
    }
}
exports.DesktopGallery = DesktopGallery;
